import React, { useState } from "react";
import {
  Instagram,
  Facebook,
  X,
  Globe,
  Mail,
  Phone,
  MapPin,
  MessageSquare,
  HelpCircle,
  Send,
  AlertCircle,
  Linkedin,
  Youtube,
  Clock,
  Users,
  Star,
} from "lucide-react";
import { FaTiktok } from "react-icons/fa6";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    feedbackType: "general",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form gönderildi:", formData);
    alert("Mesajınız gönderildi! Teşekkür ederiz.");
    setFormData({ name: "", email: "", message: "", feedbackType: "general" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const supportOptions = [
    {
      title: "Teknik Destek",
      description: "Platform ile ilgili teknik sorunlar",
      color: "bg-purple-500",
      icon: <HelpCircle className="w-6 h-6" />,
    },
    {
      title: "İşbirliği",
      description: "Kurumsal işbirlikleri ve ortaklıklar",
      color: "bg-purple-500",
      icon: <Users className="w-6 h-6" />,
    },
    {
      title: "Öneri",
      description: "Platform geliştirme önerileriniz",
      color: "bg-purple-500",
      icon: <MessageSquare className="w-6 h-6" />,
    },
  ];

  return (
    <div className="min-h-screen px-4 py-12">
      <div className="max-w-7xl mx-auto">
        {/* Hero Bölümü */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 bg-purple-500 text-white font-normal 
          px-4 py-2 rounded-full mb-6"
          >
            <MessageSquare className="w-5 h-5 text-white" />
            <span className="font-semibold">Bizimle İletişim</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            Size
            <span className="text-text-gray-900">
              {" "}
              Nasıl Yardımcı Olabiliriz?
            </span>
          </h1>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Sorularınız, önerileriniz veya geri bildirimleriniz için buradayız.
            Classroom ekibi olarak size en iyi desteği sunmak için hazırız.
          </p>
        </div>
        {/* Ana İletişim Grid */}
        <div className="grid grid-cols-1 xl:grid-cols-8 gap-8 mb-16  ">
          {/* 📌 Temel Bilgiler */}
          <div className=" col-span-3 bg-white rounded-2xl shadow-xl p-8  border border-gray-100">
            <div className="flex items-center gap-3 mb-8 0">
              <div className="bg-purple-100 p-3 rounded-full">
                <Mail className="w-8 h-8 text-purple-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 ">
                İletişim Bilgileri
              </h2>
            </div>

            <div className="space-y-6">
              <div
                className="flex flex-col  items-start gap-4 p-4 bg-gray-50
               rounded-xl hover:bg-purple-50 transition-colors"
              >
                <div className="bg-purple-500 p-3 rounded-lg shadow-sm">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 font-medium">
                    E-posta Adresi
                  </p>
                  <a
                    href="mailto:classroom.destek@gmail.com"
                    className="text-lg text-gray-900 hover:text-purple-600 transition-colors"
                  >
                    classroom.destek@gmail.com
                  </a>
                </div>
              </div>

              <div
                className="flex flex-col  items-start gap-4 p-4 bg-gray-50 rounded-xl
               hover:bg-purple-50 transition-colors"
              >
                <div className="bg-purple-500 p-3 rounded-lg shadow-sm">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 font-medium">
                    Telefon Numarası
                  </p>
                  <a
                    href="tel:05344550121"
                    className="text-lg text-gray-900 hover:text-purple-600 transition-colors"
                  >
                    0534 455 01 21
                  </a>
                </div>
              </div>

              <div
                className="flex  flex-col  items-start gap-4 p-4 bg-gray-50 rounded-xl
               hover:bg-purple-50 transition-colors"
              >
                <div className="bg-purple-500 p-3 rounded-lg shadow-sm">
                  <MapPin className="w-6 h-6 text-whiteS text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 font-medium">
                    Fiziksel Adres
                  </p>
                  <p className="text-lg text-gray-900">Diyarbakır, Türkiye</p>
                </div>
              </div>
            </div>

            {/* Destek Seçenekleri */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Hızlı Destek Seçenekleri
              </h3>
              <div className="space-y-4">
                {supportOptions.map((option, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 rounded-xl border
                     border-gray-200 hover:border-purple-300 transition-colors"
                  >
                    <div
                      className={`${option.color} text-white p-3 rounded-full`}
                    >
                      {option.icon}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">
                        {option.title}
                      </h4>
                      <p className="text-sm text-gray-600">
                        {option.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 💬 İletişim Formu */}
          <div
            className="col-span-5 bg-gradient-to-br from-purple-50
           to-white rounded-2xl shadow-xl p-8 border border-purple-100"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="bg-purple-500 p-3 rounded-full">
                <Send className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">
                Mesaj Gönderin
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Adınız Soyadınız
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 
                    rounded-xl focus:ring-2 focus:ring-purple-500
                     focus:border-purple-500 transition-all"
                    placeholder="Adınızı giriniz"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    E-posta Adresiniz
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl 
                    focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                    placeholder="email@example.com"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Konu
                </label>
                <select
                  name="feedbackType"
                  value={formData.feedbackType}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                >
                  <option value="general">Genel Soru</option>
                  <option value="support">Teknik Destek</option>
                  <option value="feedback">Geri Bildirim</option>
                  <option value="bug">Hata Bildirimi</option>
                  <option value="suggestion">Öneri</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Mesajınız
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                  placeholder="Mesajınızı buraya yazınız..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-purple-600
                 to-purple-700 text-white font-semibold py-4 px-6 rounded-xl
                  hover:from-purple-700 hover:to-purple-800 transition-all
                   duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
              >
                <Send className="w-5 h-5" />
                Mesajı Gönder
              </button>
            </form>
          </div>
        </div>

        {/* 🌐 Sosyal Medya ve Destek */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Sosyal Medya */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex items-center gap-3 mb-8">
              <div className="bg-yellow-500 p-3 rounded-full">
                <Globe className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Sosyal Medya</h2>
            </div>

            <p className="text-gray-600 mb-6">
              Bizi sosyal medyada takip edin, en güncel haberleri ve duyuruları
              kaçırmayın.
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {[
                {
                  platform: "Instagram",
                  icon: <Instagram className="w-8 h-8 text-pink-600" />,
                  handle: "@Class_room2026",
                  color: "bg-pink-50",
                  link: "https://www.instagram.com/class_room2026?igsh=MWlrb3YxMzhsdXlyNg==",
                },
                {
                  platform: "Facebook",
                  icon: <Facebook className="w-8 h-8 text-blue-600" />,
                  handle: "@classroom2026",
                  color: "bg-blue-50",
                  link: "https://www.facebook.com/share/14SpcWE439q/",
                },
                // {
                //   platform: "Twitter",
                //   icon: <X className="w-8 h-8 text-black" />,
                //   handle: "@Cass_room",
                //   color: "bg-gray-50",
                //   link: "https://twitter.com/Cass_room",
                // },
                {
                  platform: "YouTube",
                  icon: <Youtube className="w-8 h-8 text-red-600" />,
                  handle: "@class_Room21",
                  color: "bg-red-50",
                  link: "https://youtube.com/@class_room21?si=VptQcA_za0E-aTzF",
                },
                {
                  platform: "TikTok",
                  icon: <FaTiktok className="w-8 h-8 text-black" />,
                  handle: "@class_room021",
                  color: "bg-gray-50",
                  link: "https://www.tiktok.com/@class_room021?is_from_webapp=1&sender_device=pc",
                },
                // {
                //   platform: "LinkedIn",
                //   icon: <Linkedin className="w-8 h-8 text-blue-700" />,
                //   handle: "@classroom",
                //   color: "bg-blue-50",
                //   link: "#",
                // },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${social.color} rounded-2xl p-4 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-200`}
                >
                  <div className="flex justify-center mb-3">
                    <div className="p-3 bg-white rounded-full">
                      {social.icon}
                    </div>
                  </div>
                  <h3 className="font-semibold text-gray-900">
                    {social.platform}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">{social.handle}</p>
                </a>
              ))}
            </div>
          </div>

          {/* Acil Destek */}
          <div className="bg-white rounded-2xl p-8 shadow-xl ">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-yellow-500 p-3 rounded-full">
                <AlertCircle className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-700">Acil Destek</h2>
            </div>

            <p className="text-gray-700 text-lg mb-6">
              Acil durumlarda ve teknik sorunlar için 7/24 destek hattımızdan
              bize ulaşabilirsiniz.
            </p>

            <div className="bg-purple-500 rounded-2xl p-6 mb-6">
              <div className="flex items-center gap-4">
                <div className="bg-yellow-500 p-3 rounded-full">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">
                    Acil Çağrı Merkezi
                  </h3>
                  <a
                    href="tel:05344550121"
                    className="text-2xl font-bold text-white hover:text-purple-800 transition-colors"
                  >
                    0534 455 01 21
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-purple-500 backdrop-blur-sm rounded-xl p-4">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-white mt-1" />
                <div>
                  <h4 className="font-semibold text-white">
                    Çalışma Saatlerimiz
                  </h4>
                  <p className="text-white/90 text-sm">
                    Pazartesi - Cuma: 09:00 - 18:00
                    <br />
                    <span className="text-white">
                      * Acil durumlarda 7/24 ulaşılabilirsiniz
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sonuç */}
        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">
            Sorularınızı Yanıtlamak İçin Buradayız
          </h3>
          <p className="text-gray-600 text-lg mb-8">
            Classroom ekibi olarak, her türlü soru ve geri bildiriminizi
            önemsiyoruz. Sizin için en iyi deneyimi sunmak için sürekli
            çalışıyoruz.
          </p>
          {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              className="bg-purple-500 text-white font-semibold px-8 py-3
             rounded-xl hover:bg-purple-600 transition-colors shadow-lg"
            >
              Sıkça Sorulan Sorular
            </button>
            <button
              className="bg-purple-500 text-white font-semibold px-8 py-3
             rounded-xl hover:bg-purple-600 transition-colors shadow-lg"
            >
              Canlı Destek
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Contact;
